import React from 'react';
import { Row, Col, Button, Table, Checkbox, Pagination } from 'react-bootstrap';
import { labelUrl } from '../config';

export default class GearModelList2Component extends React.Component {

  constructor(props) {
    super(props);
    this.handleChangeActivepage = this.handleChangeActivepage.bind(this);
    this.checkBoxMap = new Map();
  }

  componentDidMount() {
    if (this.props.refresh) {
      this.props.refresh({ activePage: this.props.activePage, itemPerPage: this.props.itemPerPage });
    }
  }

  componentWillUnmount() {
  }

  handleAdd() {
    this.props.openAddModal();
  }

  handleEdit(pk) {
    this.props.handleEdit(pk);
  }

  handleUpload(pk) {
    this.props.openUploadModal(pk);
  }

  handleDownload(pdf) {
    let url = labelUrl + pdf;
    window.open(url);
  }

  handleDelete() {
    let r = confirm('確認刪除 ?');
    if (r === true) {
      let deleteKey = [];
      for (let key of this.checkBoxMap.keys()) {
        if (this.checkBoxMap.get(key)) {
          if (this.checkBoxMap.get(key).checked) {
            deleteKey.push(key);
          }
        }
      }
      this.props.deleteItems(deleteKey, { activePage: this.props.activePage, itemPerPage: this.props.itemPerPage });
    }
  }

  handleChangeActivepage(eventKey) {
    if (this.props.changeActivepage) {
      this.props.changeActivepage({
        activePage: eventKey,
        itemPerPage: this.props.itemPerPage
      });
    }
  }

  render() {

    let tableRows = [];
    if (this.props.data) {
      for (let i = 0; i < this.props.data.size; i++) {
        let row = this.props.data.get(i);
        let modelNo = row.get('model_no');
        let pk = { model_no: modelNo };

        let rowObj = [];
        rowObj.push((
          <td key='checkBoxes' style={{ textAlign: 'center', width: 1 }}><Checkbox inline inputRef={(ref) => this.checkBoxMap.set(pk, ref)} /></td>
        ));
        rowObj.push((
          <td key='edits' style={{ width: 1 }}>
            <Button bsStyle="default" onClick={(event) => {
              this.handleEdit(pk);
            }}><span className="glyphicon glyphicon-pencil" style={{ marginRight: 10 }} />Edit</Button>
          </td>
        ));
        rowObj.push((
          <td key='uploads' style={{ width: 1 }}>
            <Button bsStyle="default" onClick={(event) => {
              this.handleUpload(pk);
            }}><span className="glyphicon glyphicon-upload" style={{ marginRight: 10 }} />Upload</Button>
          </td>
        ));
        rowObj.push((
          <td key='modelDisplayName'>
            {row.get('model_display_name')}
          </td>
        ));

        let showTemplateA = (row.get('template_a')) ? '' : 'none';
        let showTemplateB = (row.get('template_b')) ? '' : 'none';
        let showTemplateNewA = (row.get('template_new_a')) ? '' : 'none';
        let showTemplateNewB = (row.get('template_new_b')) ? '' : 'none';
        let showTemplateNewC = (row.get('template_new_c')) ? '' : 'none';
        let showTemplateOther = (row.get('template_other')) ? '' : 'none';
        let sizeTypeDisplay = (row.get('size_type_display')) ? (row.get('size_type_display')) : '';

        rowObj.push((
          <td key='sizeType'>
            {sizeTypeDisplay}
          </td>
        ));
        rowObj.push((
          <td key='templateA' style={{ width: 50 }}>
            <Button bsStyle="default" style={{ display: showTemplateA }} onClick={(event) => {
              this.handleDownload(row.get('template_a'));
            }}><span className="glyphicon glyphicon-download" /></Button>
          </td>
        ));
        rowObj.push((
          <td key='templateB' style={{ width: 50 }}>
            <Button bsStyle="default" style={{ display: showTemplateB }} onClick={(event) => {
              this.handleDownload(row.get('template_b'));
            }}><span className="glyphicon glyphicon-download" /></Button>
          </td>
        ));
        rowObj.push((
          <td key='templateNewA' style={{ width: 50 }}>
            <Button bsStyle="default" style={{ display: showTemplateNewA }} onClick={(event) => {
              this.handleDownload(row.get('template_new_a'));
            }}><span className="glyphicon glyphicon-download" /></Button>
          </td>
        ));
        rowObj.push((
          <td key='templateNewB' style={{ width: 50 }}>
            <Button bsStyle="default" style={{ display: showTemplateNewB }} onClick={(event) => {
              this.handleDownload(row.get('template_new_b'));
            }}><span className="glyphicon glyphicon-download" /></Button>
          </td>
        ));
        rowObj.push((
          <td key='templateNewC' style={{ width: 50 }}>
            <Button bsStyle="default" style={{ display: showTemplateNewC }} onClick={(event) => {
              this.handleDownload(row.get('template_new_c'));
            }}><span className="glyphicon glyphicon-download" /></Button>
          </td>
        ));
        rowObj.push((
          <td key='templateOther' style={{ width: 50 }}>
            <Button bsStyle="default" style={{ display: showTemplateOther }} onClick={(event) => {
              this.handleDownload(row.get('template_other'));
            }}><span className="glyphicon glyphicon-download" /></Button>
          </td>
        ));

        tableRows.push((
          <tr key={modelNo}>
            {rowObj}
          </tr>
        ));
      }
    }

    let paging = null;
    paging = (<Pagination
      prev
      next
      first
      last
      ellipsis
      boundaryLinks
      items={this.props.totalPage}
      maxButtons={this.props.pagingMaxButtons}
      activePage={this.props.activePage}
      onSelect={this.handleChangeActivepage} />);

    return (
      <div>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={2} sm={1} md={1}>
            <div style={{ paddingTop: 10, paddingBottom: 10 }}>
              <Button bsStyle="default" onClick={(event) => {
                this.handleAdd();
              }}>
                <span className="glyphicon glyphicon-plus" style={{ marginRight: 10 }} />Add
              </Button>
            </div>
          </Col>
        </Row>
        <Table bordered condensed hover striped>
          <thead>
            <tr>
              <th colSpan={3}>
                <div style={{ paddingTop: 10, paddingBottom: 10, textAlign: 'center' }}>
                  <Button bsStyle="default" onClick={(event) => {
                    this.handleDelete();
                  }}>
                    <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
                    <span style={{ color: '#a94442' }}>Delete</span>
                  </Button>
                </div>
              </th>
              <th style={{ verticalAlign: 'middle' }}>型號顯示名稱</th>
              <th style={{ verticalAlign: 'middle' }}>類型</th>
              <th style={{ verticalAlign: 'middle' }}>舊(左)</th>
              <th style={{ verticalAlign: 'middle' }}>舊(右)</th>
              <th style={{ verticalAlign: 'middle' }}>新(左)</th>
              <th style={{ verticalAlign: 'middle' }}>新(右)</th>
              <th style={{ verticalAlign: 'middle' }}>新(橫)</th>
              <th style={{ verticalAlign: 'middle' }}>其他</th>
            </tr>
          </thead>
          <tbody>
            {tableRows}
          </tbody>
        </Table>
        <div style={{ width: '100%', textAlign: 'right', marginTop: -20 }}>
          {paging}
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/components/GearModelList2Component.jsx